import { css, setColor_25476d, setFontSize_13px, setFontWeight600, setProps, styled } from "theme";

interface SFetchedFilterSelectTitleProps {
  isArabic: boolean;
}

const isArabicLang = setProps<SFetchedFilterSelectTitleProps>(({ isArabic }) => isArabic)(css`
  text-align: right;
`);

export const SFetchedFilterSelectTitle = styled.div<SFetchedFilterSelectTitleProps>`
  margin-top: 8px;
  margin-bottom: 8px;

  ${isArabicLang};
  ${setFontSize_13px};
  ${setFontWeight600};
  ${setColor_25476d};
`;
